import { StepRun } from "@/models/flows";
import { dateToPortalDisplay, formatDateWithTime } from "@/utils/date";
import { ClockIcon } from "lucide-react";

interface Props {
  stepRun: StepRun;
}

export const DelayStep = ({ stepRun }: Props) => {
  return (
    <div>
      <div className="flex items-start">
        <div>
          <div className="dark:text-white">
            {stepRun.renderedConfig.subject}
          </div>
          <div className="flex mt-1 items-center text-zinc-500 dark:text-white">
            <ClockIcon className="h-4 w-4 mr-1.5" />
            <p className="">
              Wait{" "}
              {stepRun.renderedConfig.duration
                ? stepRun.renderedConfig.duration
                : `until ${formatDateWithTime(stepRun.renderedConfig.until)}`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
